import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', label: '首页', to: '/' },
  { icon: 'ri-heart-line', activeIcon: 'ri-heart-fill', label: '故事', to: '/stories' },
  { icon: 'ri-vip-crown-line', activeIcon: 'ri-vip-crown-fill', label: '会员', to: '/membership' },
  { icon: 'ri-store-2-line', activeIcon: 'ri-store-2-fill', label: '好物', to: '/warehouse' },
  { icon: 'ri-user-line', activeIcon: 'ri-user-fill', label: '我的', to: '/auth' },
];

export default function BottomNav() {
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <div className="flex items-stretch h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.to;
          return (
            <Link
              key={item.to}
              to={item.to}
              className="flex-1 flex flex-col items-center justify-center gap-0.5 cursor-pointer transition-all active:scale-95"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-xl transition-all duration-200 ${isActive ? 'bg-red-50' : ''}`}>
                <i className={`${isActive ? item.activeIcon : item.icon} text-xl transition-all duration-200 ${isActive ? 'text-red-600' : 'text-gray-400'}`}></i>
              </div>
              <span className={`text-[10px] font-medium transition-colors duration-200 ${isActive ? 'text-red-600' : 'text-gray-400'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
